import { render, staticRenderFns } from "./anime.vue?vue&type=template&id=da8c1142&scoped=true"
import script from "./anime.vue?vue&type=script&lang=js"
export * from "./anime.vue?vue&type=script&lang=js"
import style0 from "./anime.vue?vue&type=style&index=0&id=da8c1142&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da8c1142",
  null
  
)

export default component.exports